const translations = {
  translation: {
    appTitle: '단위 변환기',
    appDescription: '11가지 카테고리에서 즉시 단위 변환',
    selectCategory: '카테고리 선택',
    categories: {
      length: '길이',
      mass: '질량',
      force: '힘',
      energy: '에너지',
      power: '전력',
      pressure: '압력',
      temperature: '온도',
      time: '시간',
      volume: '부피',
      angle: '각도',
      area: '면적',
    },
    units: {
      // Length
      meter: '미터',
      kilometer: '킬로미터',
      centimeter: '센티미터',
      millimeter: '밀리미터',
      micrometer: '마이크로미터',
      nanometer: '나노미터',
      mile: '마일',
      yard: '야드',
      foot: '피트',
      inch: '인치',
      nauticalMile: '해리',
      // Mass
      kilogram: '킬로그램',
      gram: '그램',
      milligram: '밀리그램',
      metricTon: '톤',
      pound: '파운드',
      ounce: '온스',
      ton: '미국 톤',
      stone: '스톤',
      // Force
      newton: '뉴턴',
      kilonewton: '킬로뉴턴',
      poundForce: '파운드힘',
      kilopoundForce: '킬로파운드힘',
      dyne: '다인',
      // Energy
      joule: '줄',
      kilojoule: '킬로줄',
      calorie: '칼로리',
      kilocalorie: '킬로칼로리',
      wattHour: '와트시',
      kilowattHour: '킬로와트시',
      electronvolt: '전자볼트',
      btu: 'BTU',
      footPound: '피트파운드',
      // Power
      watt: '와트',
      kilowatt: '킬로와트',
      megawatt: '메가와트',
      horsepower: '마력',
      btuPerHour: 'BTU/시간',
      // Pressure
      pascal: '파스칼',
      kilopascal: '킬로파스칼',
      bar: '바',
      atmosphere: '기압',
      psi: 'PSI',
      torr: '토르',
      mmHg: '수은주밀리미터',
      // Temperature
      celsius: '섭씨',
      fahrenheit: '화씨',
      kelvin: '켈빈',
      // Time
      second: '초',
      millisecond: '밀리초',
      microsecond: '마이크로초',
      nanosecond: '나노초',
      minute: '분',
      hour: '시간',
      day: '일',
      week: '주',
      month: '월',
      year: '년',
      // Volume
      liter: '리터',
      milliliter: '밀리리터',
      cubicMeter: '세제곱미터',
      cubicCentimeter: '세제곱센티미터',
      gallon: '갤런',
      quart: '쿼트',
      pint: '파인트',
      cup: '컵',
      fluidOunce: '액량온스',
      tablespoon: '테이블스푼',
      teaspoon: '티스푼',
      // Angle
      degree: '도',
      radian: '라디안',
      gradian: '그라디안',
      arcminute: '분',
      arcsecond: '초',
      turn: '회전',
      // Area
      squareMeter: '제곱미터',
      squareKilometer: '제곱킬로미터',
      squareCentimeter: '제곱센티미터',
      squareMillimeter: '제곱밀리미터',
      hectare: '헥타르',
      acre: '에이커',
      squareMile: '제곱마일',
      squareYard: '제곱야드',
      squareFoot: '제곱피트',
      squareInch: '제곱인치',
      pyeong: '평',
    },
    from: '원본',
    to: '변환',
    enterValue: '값 입력',
    result: '결과',
  },
};

export default translations;
